(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  if (window.location.href.includes("/outlet")) {
    let newURL = window.location.href;
    let needReload = false;
    if (window.location.href.includes("filter.v.availability=0")) {
      newURL = newURL.replace("filter.v.availability=0", "").replace("&&", "&");
      needReload = true
    }
    if (!newURL.includes("filter.v.availability=1")) {
      newURL = `${newURL}${newURL.includes("/outlet?") ? "&filter.v.availability=1" : "?filter.v.availability=1"}`;
      needReload = true
    }
    if (needReload) {
      window.location.replace(newURL)
    }
    setInterval(() => {
      let needReload = false;
      if (window.location.href.includes("filter.v.availability=0")) {
        needReload = true
      }
      if (!window.location.href.includes("filter.v.availability=1")) {
        needReload = true;
      }
      if (needReload) {
          console.log("reloading")
          window.location.reload()
      };
      }, 3000); 
  }

  } catch(e) { console.error(e); }
})();
})();
